import { SystemFont } from "@/types/common"


/**
 * 判断操作系统是否存在某字体
 * @param fontName 字体名
 */
export const getSupportFonts = (fontNames: SystemFont[]) => {
  return fontNames
}

export async function loadFont(fontFamily: string) {
  let font
  try {
    const fonts = await window.queryLocalFonts();
    font = fonts.filter(item => item.family === fontFamily)[0]
  } catch(e: any) {
  } finally {
    return font
  }
}